<template>
  <div class="menu">
    <section class="section">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="title">Menu</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <router-link class="button is-info" :to="{name: 'menu.create'}">
              Create
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <b-table :data="menus ? menus.docs : []">
        <template slot-scope="props">
          <b-table-column label="Content">
            <p class="field">{{ props.row.name }}</p>
            <p class="field">
              <a :href="`${$websiteUrl}/section/${props.row.slug}`" target="_blank">
                {{ `${$websiteUrl}/section/${props.row.slug}` }}
              </a>
            </p>
            <p class="field">
              <span class="tags">
                <span class="tag" v-for="tag in props.row.Tags" :key="tag.id">
                  {{ tag.name }}
                </span>
              </span>
            </p>
            <p class="field">
              <span class="is-size-7 has-text-grey is-italic">
                Last modify {{ $moment(props.row.updatedAt || props.row.createdAt)
                  .format('D MMM Y HH:mm:ss') }}
              </span>
            </p>
          </b-table-column>
          <b-table-column label="Action" centered>
            <div class="buttons">
              <router-link
                class="button is-warning"
                :to="{name: 'menu.info', params: {id: props.row.id}}"
              >
                <b-icon icon="edit" size="is-small" />
              </router-link>
              <button class="button is-danger" @click="onDelete(props.row.id)">
                <b-icon icon="trash-alt" size="is-small" />
              </button>
            </div>
          </b-table-column>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'my-menu',
  computed: {
    ...mapGetters('menu', ['menus']),
  },
  methods: {
    ...mapActions('menu', ['getMenus', 'deleteMenu']),
    fetch() {
      this.getMenus({
        page: this.$route.query.page || 1,
      });
    },
    onDelete(id) {
      this.$swal.fire({
        title: 'Delete ?',
        type: 'warning',
        showCancelButton: true,
        /* eslint-disable arrow-body-style */
        preConfirm: () => {
          return this.deleteMenu(id);
        },
        /* eslint-enable arrow-body-style */
      }).then(() => {
        this.fetch();
        this.$swal.fire('Deleted!');
      });
    },
    getThumbnail(assets) {
      const thumbnail = assets.find(i => i.type === 'thumbnail');

      return thumbnail ? thumbnail.url : null;
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
